export interface SetParseErrorActionType {
  type: '@standard/SET_PARSE_ERROR';
}

export const setParseError = (): SetParseErrorActionType => ({
  type: '@standard/SET_PARSE_ERROR',
});
